import { useCallback, useEffect, useState } from 'react'

import {
  misProductosService,
  type ProductoDetalle,
  type ProductoResumen,
} from '@/features/dashboard/services/misProductos.service'

export function useMisProductos(lang?: string) {
  const [productos, setProductos] = useState<ProductoResumen[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    setLoading(true)
    setError(null)

    misProductosService
      .listar(lang)
      .then((data) => {
        if (!cancelled) setProductos(data)
      })
      .catch(() => {
        if (!cancelled) setError('No se pudieron cargar los productos.')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => { cancelled = true }
  }, [lang])

  return { productos, loading, error }
}

export function useMisProductosDetalle(id: string | null, lang?: string) {
  const [detalle, setDetalle] = useState<ProductoDetalle | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchDetalle = useCallback((productoId: string, currentLang?: string) => {
    setLoading(true)
    setError(null)

    misProductosService
      .obtenerDetalle(productoId, currentLang)
      .then((data) => setDetalle(data))
      .catch(() => setError('No se pudo cargar el detalle del producto.'))
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    if (id) fetchDetalle(id, lang)
  }, [id, lang, fetchDetalle])

  return { detalle, loading, error }
}
